const transformChatContextResponse = (response) => {
  const transformed = {};
  Object.entries(response.data.sfProperties).forEach(([key, value]) => {
    transformed[key] = value.value;
  });
  return {
    caseData: transformed,
    queueInfo: response.data.additionalProperties.sfConfig || "default"
  };
};

export { transformChatContextResponse };
//# sourceMappingURL=src-utils-chat-chat-case-transform-utils.js.map
